import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class PageHeaderComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR: string = ".js-ina-header";

    private _classMap = {
        js: {
            icons: ".js-ina-header__icons",
            burger: ".js-ina-header__burger",
            navigation: ".js-ina-navigation"
        }
    };

    private _currentContext: JQuery = $();
    private _isMobile: boolean;
    private _window: JQuery<Window> = $(window);

    private _pageScroll = (): void => {
        $("body").css("--page-scroll", this._window[0].scrollY.toString() + "px");
    };

    public set IsMobile(isMobile: boolean) {
        this._isMobile = isMobile;
    }

    public updateStyles(): void {
        let iconsHeight = "0";
        const headerIconsHeight = $(this._classMap.js.icons, this._currentContext).outerHeight();
        if(headerIconsHeight)
        {
            iconsHeight = headerIconsHeight.toFixed(0);
        }
        $("body").css("--header-icons-height", iconsHeight + "px");
    }

    private initStyles(): void {
        this.setHeaderHeight();
        this._pageScroll();
    }

    private setHeaderHeight(): void {
        const headerHeight = this._currentContext.outerHeight().toFixed(0);
        $("body").css("--header-height", headerHeight.toString() + "px");
    }

    public getHeight(): number {
        return this._currentContext.height();
    }

    private bindEvents(): void {
        this._window.on("scroll", this._pageScroll);

        const burger = $(this._classMap.js.burger, this._currentContext);

        burger.on("click", () => {
            burger.toggleClass("open");

            const navigationContext = $(this._classMap.js.navigation);
            navigationContext.toggleClass("hidden");
            navigationContext.toggleClass("show");

            if (this._isMobile) {
                this.emit("menu/click");

                this._window.off("scroll", this._pageScroll);
                const scrollPositionValue = Number($("body").css("--page-scroll").slice(0, -2));

                if (burger.hasClass("open")) {
                    $("body").addClass("body-overflow");
                }
                else {
                    $("body").removeClass("body-overflow");
                    const scrollPosition = scrollPositionValue;
                    this._window[0].scrollTo(0, scrollPosition);
                    this._window.on("scroll", this._pageScroll);
                }
            }
        });

        this._window.on("load", () => {
            this.setHeaderHeight();
        });
    }

    public init($context: JQuery): void {
        this._currentContext = $context || this._currentContext;

        this.initStyles();
        this.bindEvents();
    }
}
